import { proxy, useSnapshot } from 'valtio'
import { useMemo } from 'react'
import { getAuthProvider } from '@/shared/api/auth-provider'

/** 是否是测试环境打包模式 */
export const IS_SERVER_TEST = import.meta.env.VITE_SERVER_TEST == 'true';
/** 是否是线上打包模式 */
export const IS_SERVER_REAL = !IS_SERVER_TEST;

export const globalConfigStore = proxy<{
    globalConfig: GlobalConfigData | null
    copy_point: number
    videoEditorDebug: boolean
}>({
    globalConfig: null,
    copy_point: 10,
    videoEditorDebug: false,
})

export interface GlobalConfigData {
    canvas_config: {
        default_tts?: Record<string, unknown>
        qywx: string,
        video_preset?: {
            image_to_video: {
                reference: {
                    width: number,
                    height: number
                    url: string
                },
                prompt: string,
            },
            start_end_frame: {
                start_frame: {
                    width: number,
                    height: number
                    url: string
                },
                end_frame: {
                    width: number,
                    height: number
                    url: string
                },
                prompt: string,
            }

        }
        text_preset?: {
            image_to_text: {
                reference: {
                    width: number,
                    height: number
                    url: string
                },
                prompt: string,
            }
        }
        [key: string]: unknown
    }
    canvas_urls?: Record<string, string>
}

export function getGlobalConfig(): GlobalConfigData | null {
    return globalConfigStore.globalConfig
}

export function useCanvasUrls() {
    const { globalConfig } = useSnapshot(globalConfigStore)
    const pointRuleUrl = globalConfig?.canvas_urls?.point_rule ?? ''
    const managerUrl = globalConfig?.canvas_urls?.manager ?? ''
    const helpUrl = globalConfig?.canvas_urls?.help ?? ''
    const aiUsageRuleUrl = globalConfig?.canvas_urls?.['ai-usage-rule'] ?? ''
    const aiPublishRuleUrl = globalConfig?.canvas_urls?.['ai-publish-rule'] ?? ''
    const aiPublishAgreementUrl = globalConfig?.canvas_urls?.['ai-publish-agreement'] ?? ''
    const homeUrl = globalConfig?.canvas_urls?.home ?? ''
    const videoEditorUrl = globalConfig?.canvas_urls?.video_editor ?? ''

    const managerDetailUrl = useMemo(() => {
        if (!managerUrl) return ''
        try {
            const url = new URL(managerUrl)
            const auth = getAuthProvider()
            const token = auth.getToken()
            const uuid = auth.getUuid()
            const op_team = auth.getTeamId?.() || ''

            url.searchParams.set('menu', 'billing')
            url.searchParams.set('sub_tab', 'consume')
            if (op_team) url.searchParams.set('op_team', op_team)
            if (token) url.searchParams.set('token', token)
            if (uuid) url.searchParams.set('uuid', uuid)

            return url.toString()
        } catch (e) {
            return managerUrl
        }
    }, [managerUrl])

    return {
        pointRuleUrl,
        managerDetailUrl,
        helpUrl,
        aiUsageRuleUrl,
        aiPublishRuleUrl,
        aiPublishAgreementUrl,
        videoEditorUrl,
        homeUrl
    }
}
